import MyTransaction from "./MyTranscation";
import DashboardLayout from "./layout/DashboardLayout";

const MyTransactionComponent = () => {
  return (
    <DashboardLayout>
      <MyTransaction />
    </DashboardLayout>
  );
};

export default MyTransactionComponent;
